import React from 'react';
import { Check } from 'lucide-react';
import { cn } from '../../utils/cn';

export interface CheckboxProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type' | 'size'> {
  label?: string;
  description?: string;
  error?: string;
}

export const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(
  ({ className, label, description, error, id, checked, ...props }, ref) => {
    const inputId = id || props.name;

    return (
      <div className={cn('app-checkbox', className)}>
        <div className="app-checkbox__control">
          <input
            ref={ref}
            id={inputId}
            type="checkbox"
            checked={checked}
            className="app-checkbox__input"
            {...props}
          />
          <label htmlFor={inputId} className="app-checkbox__box" aria-hidden="true">
            {checked ? <Check className="app-checkbox__icon" strokeWidth={3} /> : null}
          </label>
        </div>
        {(label || description || error) && (
          <div className="app-checkbox__copy">
            {label ? (
              <label htmlFor={inputId} className="app-checkbox__label">
                {label}
              </label>
            ) : null}
            {description ? <p className="app-checkbox__desc">{description}</p> : null}
            {error ? <p className="app-checkbox__error">{error}</p> : null}
          </div>
        )}
      </div>
    );
  }
);

Checkbox.displayName = 'Checkbox';
